
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zestimate",
      function () {
        return require("private-next-pages/zestimate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zestimate"])
      });
    }
  